import * as ActionTypes from '../ActionTypes';

const initialState = {
    mpr_id_data: {},
    isLoading: false,
};
const AtsMprIdReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_MPRID_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.ATS_MPRID_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                mpr_id_data: action.payload?.data?.data?.[0] || {},
            };
        case ActionTypes.ATS_MPRID_GET_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case ActionTypes.ATS_MPRID_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.ATS_MPRID_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                mpr_id_data: action.payload?.data?.data?.[0] || {},
            };
        case ActionTypes.ATS_MPRID_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default AtsMprIdReducer;
